import React, { createContext, useContext, useEffect, useState } from 'react';

import { usePreviousValue } from '@/hooks/usePreviousValue';
import { Context } from '@/types/context';

const DBSyncContext = createContext<Context.DBSync.Value>({
    isInitialSyncInProgress: true,
    isSyncInProgress: true,
    isUnsynced: false,
    hasSyncIssue: false,
    isSyncModalVisible: false,
    isInitialSyncCompleted: false,
    setIsInitialSyncInProgress: () => null,
    setIsSyncInProgress: () => null,
    setIsUnsynced: () => null,
    setHasSyncIssue: () => null,
    setIsSyncModalVisible: () => null,
});

const DBSyncProvider = ({ children }: Context.DBSync.Props) => {
    const [isInitialSyncInProgress, setIsInitialSyncInProgress] =
        useState(true);
    const [isSyncInProgress, setIsSyncInProgress] = useState(true);
    const [hasSyncIssue, setHasSyncIssue] = useState(false);
    const [isUnsynced, setIsUnsynced] = useState(false);
    const [isInitialSyncCompleted, setIsInitialSyncCompleted] = useState(false);

    const initialSyncPrevious = usePreviousValue(isInitialSyncInProgress);

    useEffect(() => {
        if (initialSyncPrevious && !isInitialSyncInProgress) {
            setIsInitialSyncCompleted(true);
        }
    }, [initialSyncPrevious, isInitialSyncInProgress]);

    const [isSyncModalVisible, setIsSyncModalVisible] = useState(false);

    return (
        <DBSyncContext.Provider
            value={{
                isInitialSyncInProgress,
                isSyncInProgress,
                isUnsynced,
                hasSyncIssue,
                isSyncModalVisible,
                isInitialSyncCompleted,
                setIsInitialSyncInProgress,
                setIsSyncInProgress,
                setIsSyncModalVisible,
                setIsUnsynced,
                setHasSyncIssue,
            }}
        >
            {children}
        </DBSyncContext.Provider>
    );
};

function useDBSyncContext() {
    const dbSyncContext = useContext(DBSyncContext);

    return dbSyncContext;
}

export { DBSyncContext, DBSyncProvider, useDBSyncContext };
